<div class="container-fluid px-0 d-flex flex-column min-vh-100">
  <app-page-header></app-page-header>

  <div
    class="mx-0 flex-nowrap d-flex flex-grow-1"
    [ngClass]="{
      'overflow-hidden': isDefaultHomePage(),
      'overflow-auto': !isDefaultHomePage()
    }">
    <div *ngIf="!isSubclient" 
      [ngClass]="{
        'col-md-3 col-xl-2': sidebarVisible,
        'ps-2-5-': !sidebarVisible}"
      class="bg-dark custom-sidebar d-flex flex-column">
      
      <div class="d-flex flex-column align-items-center align-items-sm-start pt-2 text-white min-vh-custom">
        <div 
          class="profile"
          [ngClass]="{ 'justify-content-center': !sidebarVisible,
            'pe-3': sidebarVisible }">
          
          <div *ngIf="sidebarVisible">
            <p class="m-0 ms-5" style="font-size: 0.8rem;">{{userName}}</p>
          </div>
          
          <img 
            src="../../assets/icons/chevron-left.svg"
            style="width: 12px; height: 18px;"
            class="mx-3 my-2 pointer"
            (click)="toggleSidebar()"
            [ngClass]="{ 'rotate-180': !sidebarVisible }">
        </div>

        <ul class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start w-100" id="menu">
          
          <!-- <ng-container *ngFor="let itemMenu of listMenu">
            <li class="nav-item w-100">
              <a 
                [routerLink]="itemMenu.routerLink" 
                [routerLinkActive]="'nav-link-active'"
                [routerLinkActiveOptions]="itemMenu.routerLink === '/' ? { exact: true } : { exact: false }"
                class="nav-link align-middle pe-3 "
                [ngClass]="{ 'ps-4-5': sidebarVisible }">
                
                <img 
                  class="icon-size me-3"
                  [ngClass]="{'truck-share-icon-size': itemMenu.label === 'Viagens Compartilhadas',
                    'ms-3': !sidebarVisible }"  
                  [src]=itemMenu.ico>      
                
                <span *ngIf="sidebarVisible" 
                  class="ms-1 d-none d-sm-inline">
                  {{itemMenu.label === 'Notificações' ? itemMenu.label + ' ' + notifications.length : itemMenu.label}}
                </span>
              </a>
            </li>
          </ng-container> -->

          <ng-container *ngFor="let itemMenu of listMenu">
            <li class="nav-item w-100">
              <a 
                [routerLink]="itemMenu.routerLink" 
                [routerLinkActive]="'nav-link-active'"
                [routerLinkActiveOptions]="itemMenu.routerLink === '/' ? { exact: true } : { exact: false }"
                class="nav-link d-flex align-items-center pe-3"
                [ngClass]="{ 'ps-4-5': sidebarVisible }">
          
                <ng-container *ngIf="itemMenu.label !== 'Notificações'; else notificationIcon">
                  <img 
                    class="icon-size me-3"
                    [ngClass]="{
                      'truck-share-icon-size': itemMenu.label === 'Viagens Compartilhadas',
                      'support-icon-size': itemMenu.label === 'Suporte',
                      'ms-3': !sidebarVisible
                    }"
                    [src]="itemMenu.ico">
                </ng-container>
          
                <ng-template #notificationIcon>
                  <div 
                    class="position-relative me-3 icon-size" 
                    [ngClass]="{
                      'text-orange': notifications.length > 0,
                      'text-secondary': notifications.length === 0,
                      'ms-3': !sidebarVisible
                    }">

                    <svg 
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24" 
                      [attr.fill]="bellColor"
                      > 
                      <path d="M20.8481 19.4056C19.6036 17.3483 18.9311 14.9957 18.9003 12.5912V8.40252C18.9003 6.17403 18.0153 4.03682 16.4399 2.46104C14.8646 0.885263 12.7279 0 10.5 0C8.2721 0 6.13544 0.885263 4.56008 2.46104C2.98471 4.03682 2.09968 6.17403 2.09968 8.40252V12.5849C2.06998 14.9915 1.39748 17.3464 0.151856 19.4056C0.0554313 19.5649 0.00306796 19.7469 0.000130756 19.9331C-0.00280645 20.1193 0.043788 20.3029 0.135141 20.4651C0.226493 20.6274 0.359321 20.7624 0.520014 20.8564C0.680708 20.9504 0.863492 20.9999 1.04964 21H19.9504C20.1365 20.9999 20.3193 20.9504 20.48 20.8564C20.6407 20.7624 20.7735 20.6274 20.8649 20.4651C20.9562 20.3029 21.0028 20.1193 20.9999 19.9331C20.9969 19.7469 20.9446 19.5649 20.8481 19.4056Z"/>
                      <path d="M11.3908 24.8253C11.7616 24.6755 12.0983 24.4339 12.3766 24.1182C12.655 23.8025 12.8679 23.4206 13 23H8C8.11698 23.3724 8.29748 23.715 8.5312 24.0083C8.76492 24.3016 9.04727 24.5398 9.36214 24.7093C9.67701 24.8788 10.0182 24.9763 10.3663 24.9962C10.7144 25.0161 11.0625 24.958 11.3908 24.8253Z"/>
                    </svg>
                      
                    <span *ngIf="notifications.length > 0"
                      class="position-absolute top-0 start-0 d-flex align-items-center justify-content-center"
                      style="width: 24px; height: 24px;">
                      {{ notifications.length }}
                    </span>
                  </div>
                </ng-template>
          
                <span *ngIf="sidebarVisible" class="ms-1 d-none d-sm-inline">
                  {{ itemMenu.label }}
                </span>
              </a>
            </li>
          </ng-container>
          

        </ul>
      </div>

      <div class="nav-item mt-auto">
        <div>
          <a class="nav-link align-middle pb-5 "
          [ngClass]="{ 'ps-4-5': sidebarVisible }" (click)="logout()">
            <img 
              class="pointer icon-size me-3"
              [ngClass]="{ 'ms-3': !sidebarVisible }"  
              src="../../assets/icons/logout.svg" 
              alt="Sair">

            <span *ngIf="sidebarVisible" 
              class="ms-1 d-none d-sm-inline pointer">
              Sair
            </span>
          </a>
        </div>
      </div>
    </div>

    <div 
      class="flex-grow-1 py-0"
      [ngClass]="{
        'overflow-hidden': isDefaultHomePage(),
        'overflow-auto': !isDefaultHomePage(),
        'px-5': !isDefaultHomePage()
      }" >
      <div class="main-scroll-content">
        <div class="d-flex align-items-center">
          <div *ngIf="isSubclient" 
            class="bi-geo-alt-fill fs-3 me-4" 
            style="color: #0069B4;">
          </div>

          <div *ngIf="!isDefaultHomePage()"
            class="title" 
            [ngClass]="{'title-shared': isSubclient}">
            {{title}}
          </div>
        </div>

        <router-outlet></router-outlet>
        
      </div>
    </div>
  </div>
</div>
